import type { AppLocale } from "@metaadsmanager/tk-master-contracts";

import { getCurrentLocale } from "./config";

type HeaderContext = { headers: Headers };

/** 为 Better Auth 的每次请求写入当前设备语言。 */
export function applyAuthLocaleHeader<T extends HeaderContext>(
  context: T,
  locale: () => AppLocale = getCurrentLocale,
): T {
  context.headers.set("Accept-Language", locale());
  return context;
}
